// extracted by mini-css-extract-plugin
export var arrows = "_2e-5";
export var decrementer = "_2e-9";
export var disabled = "_2e-3";
export var error = "_2e-1";
export var hiddenText = "_2e-a";
export var incrementer = "_2e-8";
export var input = "_2e-7";
export var inputWrapper = "_2e-0";
export var leadingIcon = "_2e-b";
export var readonly = "_2e-2";
export var regular = "_2e-6";
export var small = "_2e-4";